<template>
  <div class="container">
    <div v-if="loading">...loading</div>
    <div v-else>
      <div class="content-row">
        <p class="content-heading">Name</p>
        <p class="content-heading">Name (en)</p>
        <p class="content-heading">Address</p>
        <p class="content-heading">Address (en)</p>
        <p class="content-heading">Working hours</p>
        <p class="content-heading">Working hours (en)</p>
        <p class="content-heading">Branch Number</p>
        <p class="content-heading">Del</p>
      </div>
      <div v-if="branches.length > 0">
        <div
          v-for="branch in branches"
          class="content-row"
          :class="{'selectedRow': branch.id == currentId}"
          :key="branch.id"
          @click="toggleUpdate(branch)"
        >
          <p class="content-col">{{branch.name}}</p>
          <p class="content-col">{{branch.name_en}}</p>
          <p class="content-col">{{branch.address}}</p>
          <p class="content-col">{{branch.address_en}}</p>
          <p class="content-col">{{branch.hours}}</p>
          <p class="content-col">{{branch.hours_en}}</p>
          <p class="content-col">{{branch.number}}</p>
          <div class="content-col">
            <button
              class="btn btn-danger"
              type="button"
              disabled
              v-if="branch.id === loadingDeleteId"
            >
              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            </button>
            <button
              class="btn btn-danger"
              @click.prevent.stop="handleDeleteBranch(branch.id)"
              v-else
            >
              <i class="far fa-trash-alt"></i>
            </button>
          </div>
        </div>
      </div>
      <div v-else>No inserted branches yet...</div>
    </div>
    <hr />

    <form>
      <h2 v-if="editMode">Update branch</h2>
      <h2 v-else>Add branch</h2>
      <div class="row">
        <div class="form-group col-12 col-sm-6">
          <label class="pl-0 col-12 col-sm-12" for="name">Name</label>
          <input class="form-control col-12 col-sm-12" v-model="branch.name" />
        </div>
        <div class="form-group col-12 col-sm-6">
          <label class="pl-0 col-12 col-sm-12" for="name_en">Name (en)</label>
          <input class="form-control col-12 col-sm-12" name="name_en" v-model="branch.name_en" />
        </div>
        <div class="form-group col-12 col-sm-6">
          <label class="pl-0 col-12 col-sm-12" for="address">Address</label>
          <input class="form-control col-12 col-sm-12" v-model="branch.address" />
        </div>
        <div class="form-group col-12 col-sm-6">
          <label class="pl-0 col-12 col-sm-12" for="address_en">Address (en)</label>
          <input
            class="form-control col-12 col-sm-12"
            address="address_en"
            v-model="branch.address_en"
          />
        </div>
        <div class="form-group col-12 col-sm-6">
          <label class="pl-0 col-12 col-sm-12" for="hours">Working Hours</label>
          <input class="form-control col-12 col-sm-12" v-model="branch.hours" maxlength="200" />
        </div>
        <div class="form-group col-12 col-sm-6">
          <label class="pl-0 col-12 col-sm-12" for="hours_en">Working Hours (en)</label>
          <input class="form-control col-12 col-sm-12" hours="hours_en" v-model="branch.hours_en" maxlength="200" />
        </div>
        <div class="form-group col-12 col-sm-6">
          <label class="pl-0 col-12 col-sm-12" for="number">Branch Number</label>
          <input
            type="number"
            class="form-control col-12 col-sm-12"
            name="number"
            v-model="branch.number"
          />
        </div>
      </div>
      <div class="alert alert-danger" role="alert" v-if="errors.length > 0">
        <p v-for="(error, index) in errors" :key="index">{{error}}</p>
      </div>

      <button class="btn btn-primary" type="button" disabled v-if="loading">
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        Loading
      </button>

      <button
        v-if="editMode && !loading"
        class="btn btn-primary"
        @click.prevent="handleUpdateBranch"
      >Update</button>
      <button
        v-if="editMode && !loading"
        class="btn btn-success"
        @click.prevent="switchAddMode"
      >Add More</button>
      <button
        v-if="!editMode && !loading"
        class="btn btn-primary"
        @click.prevent="handleAddBranch"
      >Add</button>
    </form>
    <mapsComponent :onlyMaps="true" />
  </div>
</template>

<script>
import axios from "axios";
import { herokuUrl } from "../apiConfig";
import { getCookie } from "../cookie";
import mapsComponent from "./ContactEmails.vue";
export default {
  components: {
    'mapsComponent': mapsComponent
  },
  data() {
    return {
      branches: [],
      branch: {
        name: "",
        name_en: "",
        number: "",
        address: "",
        address_en: "",
        hours: "",
        hours_en: ""
      },
      currentId: null,
      editMode: false,
      loading: false,
      loadingDeleteId: null,
      loadingStart: false,
      errors: []
    };
  },
  methods: {
    handleAddBranch: async function() {
      this.errors = [];
      if (this.branch.name.length === 0) {
        this.errors.push("Please insert branch name");
      } else if (this.branch.name.length < 3) {
        this.errors.push("branch name shouldn't be less than 3 characters");
      } else if (this.branch.name.length > 50) {
        this.errors.push("branch name shouldn't be more than 50 characters");
      }

      if (this.branch.name_en.length === 0) {
        this.errors.push("Please insert branch name (en)");
      } else if (this.branch.name_en.length < 3) {
        this.errors.push(
          "branch name (en) shouldn't be less than 3 characters"
        );
      } else if (this.branch.name_en.length > 50) {
        this.errors.push(
          "branch name (en) shouldn't be more than 50 characters"
        );
      }

      if (this.branch.address.length === 0) {
        this.errors.push("Please insert branch address");
      } else if (this.branch.address.length < 3) {
        this.errors.push("branch address shouldn't be less than 3 characters");
      } else if (this.branch.address.length > 150) {
        this.errors.push("branch address shouldn't be more than 150 characters");
      }

      if (this.branch.address_en.length === 0) {
        this.errors.push("Please insert branch address (en)");
      } else if (this.branch.address_en.length < 3) {
        this.errors.push(
          "branch address (en) shouldn't be less than 3 characters"
        );
      } else if (this.branch.address_en.length > 150) {
        this.errors.push(
          "branch address (en) shouldn't be more than 150 characters"
        );
      }

      if (this.branch.hours.length === 0) {
        this.errors.push("Please insert branch hours");
      } else if (this.branch.hours.length < 3) {
        this.errors.push("branch hours shouldn't be less than 3 characters");
      } else if (this.branch.hours.length > 100) {
        this.errors.push("branch hours shouldn't be more than 100 characters");
      }

      if (this.branch.hours_en.length === 0) {
        this.errors.push("Please insert branch hours (en)");
      } else if (this.branch.hours_en.length < 3) {
        this.errors.push(
          "branch hours (en) shouldn't be less than 3 characters"
        );
      } else if (this.branch.hours_en.length > 100) {
        this.errors.push(
          "branch hours (en) shouldn't be more than 100 characters"
        );
      }

      if (this.branch.number.length === 0) {
        this.errors.push("Please insert branch number");
      } else if (this.branch.number.length < 3) {
        this.errors.push("branch number shouldn't be less than 3 characters");
      } else if (this.branch.number.length > 50) {
        this.errors.push("branch number shouldn't be more than 50 characters");
      }

      if (this.errors.length === 0) {
        this.loading = true;

        const response = await axios.post(
          `${herokuUrl}/dashboard/add-branch`,
          {
            name_en: this.branch.name_en,
            name: this.branch.name,
            address_en: this.branch.address_en,
            address: this.branch.address,
            hours_en: this.branch.hours_en,
            hours: this.branch.hours,
            number: this.branch.number
          },
          {
            headers: {
              Authorization: getCookie("user"),
              "Content-Type": "Application/json"
            }
          }
        );
        this.loading = false;

        if (response.data.status) {
          this.branches.push({
            id: response.data.id,
            name_en: this.branch.name_en,
            name: this.branch.name,
            address_en: this.branch.address_en,
            address: this.branch.address,
            hours_en: this.branch.hours_en,
            hours: this.branch.hours,
            number: this.branch.number
          });
          this.branch.name_en = "";
          this.branch.name = "";
          this.branch.address = "";
          this.branch.address_en = "";
          this.branch.hours = "";
          this.branch.hours_en = "";
          this.branch.number = "";
        } else {
          alert(
            "Failed to add branch, " +
              response.data.message +
              " Check if mobile number is unique"
          );
        }
      }
    },
    toggleUpdate: function(branch) {
      this.editMode = true;
      this.currentId = branch.id;
      this.branch.name = branch.name;
      this.branch.name_en = branch.name_en;
      this.branch.address = branch.address;
      this.branch.address_en = branch.address_en;
      this.branch.hours = branch.hours;
      this.branch.hours_en = branch.hours_en;
      this.branch.number = branch.number;
    },
    handleUpdateBranch: async function() {
      this.errors = [];
      if (this.branch.name.length === 0) {
        this.errors.push("Please insert branch name");
      } else if (this.branch.name.length < 3) {
        this.errors.push("branch name shouldn't be less than 3 characters");
      } else if (this.branch.name.length > 50) {
        this.errors.push("branch name shouldn't be more than 50 characters");
      }

      if (this.branch.name_en.length === 0) {
        this.errors.push("Please insert branch name (en)");
      } else if (this.branch.name_en.length < 3) {
        this.errors.push(
          "branch name (en) shouldn't be less than 3 characters"
        );
      } else if (this.branch.name_en.length > 50) {
        this.errors.push(
          "branch name (en) shouldn't be more than 50 characters"
        );
      }

      if (this.branch.address.length === 0) {
        this.errors.push("Please insert branch address");
      } else if (this.branch.address.length < 3) {
        this.errors.push("branch address shouldn't be less than 3 characters");
      } else if (this.branch.address.length > 150) {
        this.errors.push("branch address shouldn't be more than 150 characters");
      }

      if (this.branch.address_en.length === 0) {
        this.errors.push("Please insert branch address (en)");
      } else if (this.branch.address_en.length < 3) {
        this.errors.push(
          "branch address (en) shouldn't be less than 3 characters"
        );
      } else if (this.branch.address_en.length > 150) {
        this.errors.push(
          "branch address (en) shouldn't be more than 150 characters"
        );
      }

      if (this.branch.hours.length === 0) {
        this.errors.push("Please insert branch hours");
      } else if (this.branch.hours.length < 3) {
        this.errors.push("branch hours shouldn't be less than 3 characters");
      } else if (this.branch.hours.length > 100) {
        this.errors.push("branch hours shouldn't be more than 100 characters");
      }

      if (this.branch.hours_en.length === 0) {
        this.errors.push("Please insert branch hours (en)");
      } else if (this.branch.hours_en.length < 3) {
        this.errors.push(
          "branch hours (en) shouldn't be less than 3 characters"
        );
      } else if (this.branch.hours_en.length > 100) {
        this.errors.push(
          "branch hours (en) shouldn't be more than 100 characters"
        );
      }

      if (this.branch.number.length === 0) {
        this.errors.push("Please insert branch number");
      } else if (this.branch.number.length < 3) {
        this.errors.push("branch number shouldn't be less than 3 characters");
      } else if (this.branch.number.length > 50) {
        this.errors.push("branch number shouldn't be more than 50 characters");
      }

      if (this.errors.length === 0) {
        this.loading = true;
        const response = await axios.put(
          `${herokuUrl}/dashboard/update-branch`,
          {
            branchId: this.currentId,
            name_en: this.branch.name_en,
            name: this.branch.name,
            address_en: this.branch.address_en,
            address: this.branch.address,
            hours_en: this.branch.hours_en,
            hours: this.branch.hours,
            number: this.branch.number
          },
          {
            headers: {
              Authorization: getCookie("user"),
              "Content-Type": "Application/json"
            }
          }
        );
        this.loading = false;

        if (response.data.status) {
          const currentIndex = this.branches.findIndex(
            i => i.id === this.currentId
          );
          const beforeIndex = this.branches.slice(0, currentIndex);
          const afterIndex = this.branches.slice(
            currentIndex + 1,
            this.branches.length
          );

          this.branches = [
            ...beforeIndex,
            {
              id: this.currentId,
              name: this.branch.name,
              name_en: this.branch.name_en,
              address_en: this.branch.address_en,
              address: this.branch.address,
              hours_en: this.branch.hours_en,
              hours: this.branch.hours,
              number: this.branch.number
            },
            ...afterIndex
          ];
        } else {
          alert(
            "Failed to add branch, " +
              response.data.message +
              " Check if mobile number is unique"
          );
        }
      }
    },
    handleDeleteBranch: async function(branchId) {
      this.errors = [];
      this.loadingDeleteId = branchId;
      const response = await axios.delete(
        `${herokuUrl}/dashboard/delete-branch`,

        {
          data: {
            branchId
          },
          headers: {
            Authorization: getCookie("user"),
            "Content-Type": "Application/json"
          }
        },
        {
          branchId: branchId
        }
      );
      this.loadingDeleteId = null;

      if (response.data.status) {
        this.branches.splice(
          this.branches.findIndex(i => i.id === branchId),
          1
        );
        this.branch.name_en = "";
        this.branch.name = "";
        this.branch.address = "";
        this.branch.address_en = "";
        this.branch.hours = "";
        this.branch.hours_en = "";
        this.branch.number = "";
      } else {
        this.errors.push("Error in deleting branch");
      }
    },
    switchAddMode: function() {
      this.editMode = false;
      this.currentId = null;
      this.branch.name_en = "";
      this.branch.name = "";
      this.branch.address_en = "";
      this.branch.address = "";
      this.branch.hours_en = "";
      this.branch.hours = "";
      this.branch.number = "";
    }
  },
  created() {
    this.loadingStart = true;
    axios
      .get(herokuUrl + "/dashboard/branches", {
        headers: {
          Authorization: getCookie("user")
        }
      })
      .then(response => {
        if (response.data.status) {
          this.loadingStart = false;
          this.branches = response.data.branches;
        } else {
          this.loadingStart = false;
          this.error = response.data.message;
        }
      })
      .catch(err => {
        this.loadingStart = false;
        this.error = err;
      });
  }
};
</script>

<style lang="scss" scoped>
@import "../../node_modules/bootstrap/scss/bootstrap.scss";

::-webkit-scrollbar {
  width: 0px;
  height: 5px;
  background: transparent;
}
::-webkit-scrollbar-thumb {
  background: darkgray;
}
.content-row {
  width: 100%;
  padding: 5px;
  // overflow-x: scroll;
  height: auto;
  display: flex;
  justify-content: space-around;
  border-radius: 5px;
  border-style: solid;
  border-color: transparent;
  background-color: #eeeeee;
  margin-bottom: 5px;
  cursor: pointer;
  &__measurement {
    cursor: default;
    padding-bottom: 10px !important;
  }
}
.content-heading {
  text-align: center;
  width: 14%;
  font-weight: bold;
  margin-bottom: 0;
}
.selectedRow {
  background-color: #ccc;
}
.content-col {
  text-align: center;

  width: 14%;
  overflow-x: scroll;
  margin-bottom: 0;
}
</style>
